//@flow
import React, { useState } from 'react';
import styled from 'styled-components';

const StyledSpanButton = styled.span` 
    color: #fff;
    padding: 4px 12px;
    margin: 6px;
    border-radius: 2px;
    cursor: pointer;
    background-color: #265a9c;
    font-weight: bold;
    :hover{
        background-color: #517bb0;
    }
`;
const StyledText = styled.p`
    border: 1px solid #265a9c;
    padding: 6px;
    border-radius: 6px;
`;

const HiddenInfoSpan = ({title, text}) => {
    const [open, setOpen] = useState(false);

    const renderText = (text) => {
        return text.map((txt, idx) => <React.Fragment key={idx}>{txt}<br/></React.Fragment>);
    }

    return (
        <React.Fragment>
            <StyledSpanButton onClick={() => setOpen(!open)}>{title}</StyledSpanButton>
            <StyledText style={open ? {} : { display: 'none' }}>{renderText(text)}</StyledText>
        </React.Fragment >
    )
};
export default HiddenInfoSpan;


// WEBPACK FOOTER //
// ./src/components/HiddenInfoSpan.jsx